import React from "react";

export default function AISuggestionsPanel({ issues, applySingleFix }) {
  const aiSuggestions = issues.filter(
    (i) => i.suggestion && i.suggestion.trim() !== "" && i.suggestion !== i.original
  );

  if (aiSuggestions.length === 0) {
    return (
      <div
        style={{
          border: "1px solid #ddd",
          padding: 15,
          borderRadius: 8,
          background: "#fafafa",
          marginTop: 20
        }}
      >
        <h3>AI Suggestions</h3>
        <p>No AI suggestions yet.</p>
      </div>
    );
  }

  return (
    <div
      style={{
        border: "1px solid #ddd",
        padding: 15,
        borderRadius: 8,
        background: "#fafafa",
        marginTop: 20
      }}
    >
      <h3>AI Suggestions ({aiSuggestions.length})</h3>

      {aiSuggestions.map((s, idx) => (
        <div
          key={idx}
          style={{
            padding: "10px",
            marginBottom: 10,
            borderBottom: "1px solid #eee"
          }}
        >
          <strong>{s.col}</strong> — Row {s.row}
          <br />
          <span style={{ color: "red", fontWeight: "bold" }}>
            Original: {s.original}
          </span>
          <br />
          <span style={{ color: "green", fontWeight: "bold" }}>
            Suggestion: {s.suggestion}
          </span>

          <div style={{ marginTop: 5 }}>
            <button
              onClick={() => applySingleFix(s)}
              style={{
                background: "#28a745",
                color: "white",
                padding: "5px 10px",
                border: "none",
                borderRadius: 4,
                marginRight: 10,
                cursor: "pointer"
              }}
            >
              Apply Suggestion
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
